export default "__VITE_ASSET__Cq_qGSh8__"